module.exports = __webpack_public_path__ + "img/fas-check-double.a0d293b2.svg";